export function isValidJWTFormat(token) {
  if (!token || typeof token !== 'string') return false;
  const parts = token.split('.');
  return parts.length === 3 && parts.every((p) => p.length > 0);
}

export function decodeJWTPayload(token) {
  if (!isValidJWTFormat(token)) return null;

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload && typeof payload === 'object' ? payload : null;
  } catch {
    return null;
  }
}

export function getTokenExpiry(token) {
  const payload = decodeJWTPayload(token);
  if (!payload?.exp || typeof payload.exp !== 'number') return null;
  return payload.exp * 1000;
}

export function isTokenExpired(token) {
  try {
    const payload = decodeJWTPayload(token);
    if (!payload?.exp || typeof payload.exp !== 'number') return true;
    return payload.exp * 1000 < Date.now() - 5000;
  } catch {
    return true;
  }
}

export function requireAuthToken(getAccessToken) {
  const token = getAccessToken?.();
  if (!token || isTokenExpired(token)) {
    throw new Error('Not authenticated or token expired');
  }
  return token;
}
